module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "EBook-Break",
    attrs: {
      "id": "_idParaDest-7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT ParaOverride-10"
  }, [_vm._v("Characters")]), _vm._v(" "), _c('p', {
    staticClass: "_W-Opener ParaOverride-5"
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "_W ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("1844")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Elise Durel . . . age fourteen, a suburban girl")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Emile Sabatier . . . age seventeen, a boy of prospects")]), _vm._v(" "), _c('p', {
    staticClass: "_W ParaOverride-12"
  }, [_vm._v("Parts 1–5")]), _vm._v(" "), _c('p', {
    staticClass: "_W ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("1862–1863")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("New Orleans")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Joseph Woolsack . . . a slaver’s son")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Angel Woolsack . . . his father")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Elise Woolsack . . . wife of Angel, mother of Joseph")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Inés Pichon . . . her friend and neighbor, a free woman of color")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Ligeia . . . handmaid, human property of Elise Woolsack")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Dr. Emile Sabatier . . . scientist, physician, agent to Angel Woolsack")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Lydia Sabatier . . . his wife, a spiritualist")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("New England")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("General Benjamin F. Butler . . . Massachusetts jurist, politician, ­commander Union Forces, Department of the Gulf")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Sarah Butler . . . his wife")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Major George Strong . . . a Vermonter, Butler’s adjutant")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Golden Circle")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_vm._v("Marina Fandal . . . an orphan, late of Cuba")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-667849ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook43516.vue
// module id = 81
// module chunks = 0